import calculatorService, { pick, unwrap } from '@/api/calculator.service.js'
import auth from '@/authConfig.js'
import { hasValue } from '@/helpers/paymentMath.js'

/*
  The ARM index for the calculators: the latest 30-day Average SOFR, which the loan officer can
  override. Any failure resolves to null, and the page leaves the field for the LO to fill in.
*/
export async function fetchSofrIndex () {
  try {
    const tokenResponse = await auth.acquireTokenResponse()
    const data = unwrap(await calculatorService.GetSofrIndex(tokenResponse?.accessToken))
    const rate = Number(pick(data, 'rate'))
    const date = String(pick(data, 'effectiveDate') || '').slice(0, 10)
    return Number.isFinite(rate) && /^\d{4}-\d{2}-\d{2}$/.test(date) ? { rate, date } : null
  } catch (e) {
    return null
  }
}

// "2026-10-20" -> "Oct 20, 2026". Built from its parts, because new Date("2026-10-20") is UTC
// midnight and shows the day before anywhere west of Greenwich.
function asOf (date) {
  const [y, m, d] = date.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

// The note under the Index field. `sofr` is fetchSofrIndex's result; `loading` while it runs.
export function sofrIndexNote (indexPct, sofr, loading) {
  if (loading) return 'Looking up the 30-day Average SOFR...'
  if (!sofr) return 'The 30-day Average SOFR could not be loaded. Enter the index to price the ARM.'
  if (!hasValue(indexPct)) return `Enter the index to price the ARM. The 30-day Average SOFR was ${sofr.rate}% as of ${asOf(sofr.date)}.`
  return Number(String(indexPct).trim()) === sofr.rate
    ? `30-day Average SOFR, as of ${asOf(sofr.date)}`
    : `Overridden (published ${sofr.rate}% as of ${asOf(sofr.date)})`
}
